<template>
  <div class="srm-footer">
    <div class="srm-footer-content">
      <!-- 转跳链接 -->
      <div class="footer-link">
        <div
          class="footer-link-item"
          @click="changeRoute(item)"
          v-for="item in menuData"
          :key="item.name"
        >
          {{ item.label }}
        </div>
        <!-- <div class="footer-link-item">
          转跳链接1
        </div>
        <div class="footer-link-item">
          转跳链接2
        </div>
        <div class="footer-link-item">
          转跳链接3
        </div>
        <div class="footer-link-item">
          转跳链接4
        </div>
        <div class="footer-link-item">
          转跳链接5
        </div>
        <div class="footer-link-item">
          转跳链接6
        </div> -->
      </div>
      <!-- 咨询电话 -->
      <div class="footer-contact">
        <div class="footer-contact-info">
          <div>咨询热线</div>
          <div class="contact-phone">
            <!-- <div class="contact-phone-num">400-9202518</div> -->
            <!-- <div class="contact-serve-time">(服务时间：9：30 —— 17:30)</div> -->
          </div>
          <div class="contact-city">
            <div class="city-item">
              <div class="city-name">上海</div>
              <div class="city-num">021-58768609</div>
            </div>
            <!-- <div class="city-item">
              <div class="city-name">无锡</div>
              <div class="city-num">0510-81807636</div>
            </div>
            <div class="city-item">
              <div class="city-name">杭州</div>
              <div class="city-num">021-58768609</div>
            </div>
            <div class="city-item">
              <div class="city-name">南京</div>
              <div class="city-num">025-85201303</div>
            </div> -->
          </div>
        </div>
        <div class="footer-contact-qrcode">
          <img src="@/assets/qrcode.jpg" alt="" />
        </div>
      </div>
      <!-- 底部数据 -->
      <div class="copy-right">
        <div class="copy-right-num"><a href="https://beian.miit.gov.cn"  class="copy-right-num" style="
    color: #575b61;
    text-decoration: none;
" target="_blank">
沪ICP备2021005481号-2</a></div>
        <div class="copy-right-company">
          Copyright©智数魔方(上海)软件有限公司版权所有
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuData: [
        { label: '首页', name: 'home' },
        { label: '产品', name: 'product' },
        { label: '服务', name: 'service' },
        { label: '客户案例', name: 'customerCase' },
        { label: '关于我们', name: 'aboutUs' }
      ]
    }
  },
  methods: {
    changeRoute (item) {
      if (item.name === this.currentPath) return
      this.$router.push({ name: item.name })
    }
  }
}
</script>

<style lang="scss" scoped>
.srm-footer {
  // height: 256px;
  background: #1f242b;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #fff;
  .srm-footer-content {
    height: 100%;
    margin: 0 auto;
    width: 1200px;
    .footer-link {
      padding-top: 20px;
      padding-left: 10px;
      padding-right: 10px;
      padding-bottom: 10px;
      display: flex;
      border-bottom: 1px solid #5e6263;
      .footer-link-item {
        margin-right: 83px;
        cursor: pointer;
        &:hover {
          color: #5e6263;
        }
      }
    }
    .footer-contact {
      padding-top: 16px;
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      border-bottom: 1px solid #5e6263;
      .footer-contact-info {
        .contact-phone {
          margin-top: 4px;
          display: flex;
          align-items: center;
          .contact-phone-num {
            font-size: 22px;
            font-weight: bold;
            margin-right: 12px;
          }
        }
        .contact-city {
          display: flex;
          margin-top: 16px;
          padding-bottom: 26px;
          .city-item {
            margin-right: 54px;
            .city-name {
              margin-bottom: 10px;
            }
          }
        }
      }
      .footer-contact-qrcode {
        margin-bottom: 14px;
        width: 123px;
        height: 123px;
        img{
          height: 100%;
          width: 100%;
        }
      }
    }
    .copy-right {
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #575b61;
      font-size: 14px;
      .copy-right-num {
        margin-right: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/srm-footer.vue